import { useLocation } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { theme } from '../constants';
import { components } from '../components';
import useApi from '../customHook/useApi';
import { verifyOtp } from '../environment';
import { callService } from '../customHook/callService';




export interface FullProfile {
    lead_profile_id: string;
    full_name: string | null;
    email: string | null;
    phone_number: string | null;
    gender: string | null;
    dob: string | null;
    pref_budget_min_range: string | null;
    pref_budget_max_range: string | null;
    pref_city_name: string | null;
    pref_city_id: string | null;
    pref_locality_name: string | null;
    pref_locality_id: string | null;
}

export interface VerifyOtpResponse {
    success: boolean;
    statusCode: number;
    phoneNumber: string;
    accessToken: string;
    lead_profile_id: string;
    message: string;
    full_profile?: FullProfile; // ✅ optional in case it's not always present
}


export const Onboarding4: React.FC = () => {
    const location = useLocation();
    // const { phonOtp } = location.state || {};
    const { pathname } = useLocation();
    const navigate = hooks.useNavigate();
    const [otp, setOtp] = useState(['', '', '', '']);
    const [expectedOtp, setExpectedOtp] = useState(""); // Store the OTP from state
    const inputRefs = useRef<HTMLInputElement[]>([]);
    const [error, setError] = useState("")





    useEffect(() => {
        console.log(location?.state?.otp, location?.state?.phoneNumber, "from navigation");
    }, []);


    const handleChange = (value: string, index: number) => {
        if (!/^\d*$/.test(value)) return; // allow only numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const buttons = [
        {
            title: 'Verify',
            path: '/onbording5',
        }
    ];


    const {
        data: verifyOtpResponse,
        loading: verifyLoading,
        callApi: verifyOtpApi,
    } = useApi<VerifyOtpResponse>(verifyOtp, {
        method: "POST",
        autoCall: false,
        dependencies: [],
    });

    // useEffect(() => {
    //     console.log(verifyOtpResponse?.phoneNumber, "verifyOtpResponse vikas");
    //     const city = verifyOtpResponse?.full_profile?.pref_city_name;
    //     // sessionStorage.setItem("selectedCity", verifyOtpResponse?.full_profile?.pref_locality_name);

    // }, [verifyOtpResponse])


    // const varifyOtp = (path: string) => {
    //     console.log(path);
    //     console.log(otp);
    //     const enterdOtp = otp.join("")



    //     if (otp.includes("")) {
    //         setError('Please enter all 4 digits of the OTP');
    //         return
    //     }
    //     // if (enterdOtp !== '0000') {
    //     //     setError("Wrong OTP entered");
    //     //     return
    //     // }
    //     setError('');
    //     navigate(path);
    // }

    // Starts component s
    const varifyOtp = async (path: string) => {
        // console.log(otp);

        const enteredOtp = otp.join("");

        console.log(enteredOtp, "enteredOtp");


        if (otp.includes("")) {
            setError("Please enter all 4 digits of the OTP");
            return;
        }

        try {
            const res = await verifyOtpApi({
                phoneNumber: location.state?.phoneNumber,
                otp: Number(location.state.otp),
            });


            console.log(res, " i am response");


            if (res?.success) {
                console.log("OTP verified successfully:", res);

                // Optionally store data
                localStorage.setItem("accessToken", res.accessToken);
                localStorage.setItem("lead_profile_id", res.lead_profile_id);
                sessionStorage.setItem("selectedCity", res.full_profile?.pref_city_name || "");
                sessionStorage.setItem("selectedCityId", res.full_profile?.pref_city_id || "");


                // ✅ Set selected locality name (as array)
                const localityName = res.full_profile?.pref_locality_name || "";
                sessionStorage.setItem("selectedLocality", JSON.stringify([localityName]));

                // ✅ Set selected locality full object (array of one object)
                const localityId = res.full_profile?.pref_locality_id || "";
                sessionStorage.setItem("selectedLocalityFull", JSON.stringify([{
                    locality_name: localityName,
                    locality_id: Number(localityId),
                }]));

                // ✅ Set selected locality IDs as comma-separated string (or store as array if needed)
                sessionStorage.setItem("SelectedLocalityId", localityId);

                // ✅ Get gender from API
                const genderAPI = res.full_profile?.gender || "";
                sessionStorage.setItem("genderAPI", genderAPI);

                // ✅ Map API gender to human-readable value
                let genderReadable = "";
                switch (genderAPI) {
                    case "GENDER_MALE":
                        genderReadable = "Male";
                        break;
                    case "GENDER_FEMALE":
                        genderReadable = "Female";
                        break;
                    case "GENDER_OTHER":
                        genderReadable = "Other";
                        break;
                    default:
                        genderReadable = ""; // or "Prefer not to say"
                }

                sessionStorage.setItem("gender", genderReadable);

                // set min and max 
                const minAmount = res.full_profile?.pref_budget_min_range || "";
                const maxAmount = res.full_profile?.pref_budget_max_range || "";

                sessionStorage.setItem("minAmount", minAmount.toString());
                sessionStorage.setItem("maxAmount", maxAmount.toString());






                // ✅ Call LOGIN service (do not block OTP flow if this fails)
                try {
                    await callService("LOGIN", [
                        {
                            param: "MOBILE_NO",
                            value: res.phoneNumber,
                        },
                    ]);
                } catch (loginError) {
                    console.warn("LOGIN service failed after OTP verification:", loginError);
                    // Optional: Show toast or fallback
                }

                // ✅ Check for selected city in session
                const selectedCity = sessionStorage.getItem("selectedCity");
                console.log("i am selected city", selectedCity);

                if (selectedCity) {
                    navigate("/onbording6", { state: res });
                }
                else {
                    navigate(path, { state: res });
                }
            } else {
                setError(res?.message || "OTP verification failed");
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setError("Something went wrong. Please try again.");
        }
    };


    // **************** START Component Here *************

    const renderTitle = (): JSX.Element => {


        return (
            <div className='container'>
                <p className='heading'>  Enter Your Verification Code</p>
            </div>
        );
    };

    const renderDescription = (): JSX.Element => {

        const maskPhoneNumber = (phone?: string): string => {
            if (!phone) return '';
            const visibleDigits = phone.slice(-4); // last 2 digits
            return `*******${visibleDigits}`;
        };
        const maskedNumber = maskPhoneNumber(location.state?.phoneNumber);
        return (
            <div className='container'>
                <text.T16
                    style={{
                        lineHeight: 1,
                        textAlign: 'center',
                        whiteSpace: 'pre-line',
                    }}
                >
                    We’ve sent a code to +91 {maskedNumber}
                    <h1 style={{ marginTop: "10px" }}>Your OTP is : {location.state.otp}</h1>
                </text.T16>
            </div>
        );
    };
    const renderDescription2 = (): JSX.Element => {
        return (
            <div className='container'>
                <text.T16
                    style={{
                        lineHeight: 1,
                        whiteSpace: 'pre-line',
                    }}
                    onClick={() => navigate("/onbording3")}
                >
                    Resend the OTP
                </text.T16>
            </div>
        );
    };
    const renderDescription1 = (): JSX.Element => {
        return (
            <div className="container">

                <div className="otpInputContainer" style={{ marginTop: 20 }}>
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            type="tel"
                            maxLength={1}
                            value={digit}
                            onChange={e => {
                                handleChange(e.target.value, index)
                                if (error) setError("")
                            }}
                            onKeyDown={e => handleKeyDown(e, index)}
                            ref={el => (inputRefs.current[index] = el!)}
                            className="otpInputBox"
                        />
                    ))}
                </div>

                {
                    error && <div style={{ color: "red", marginTop: "12px" }}>{error}</div>
                }
            </div>
        );
    };



    const renderButtons = (): JSX.Element => (
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                padding: '36px 16px 36px 16px',
                background: ' #ffffffa1',
                backdropFilter: 'blur(4px)',
                boxSizing: 'border-box',
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,

            }}
        >
            <div
                className='button-container'
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
            >
                {renderTitle()}
                {renderDescription()}
                {renderDescription1()}
                {renderDescription2()}
                {buttons.map((btn, index) => (
                    <div
                        key={index}
                        id="onbording3"
                        className={index === 0 ? 'active-button' : 'inactive-button'}
                        onClick={() => varifyOtp(btn.path)}
                    >
                        <span>{btn.title}</span>
                    </div>
                ))}
            </div>
        </div>
    );
    return (
        <div style={{ position: 'relative', height: '100dvh', overflow: "hidden" }}>
            <div style={{ width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }}>
                <img
                    src={require('../assets/nestfin/mainb1.jpg')}
                    alt='Onboarding Visual'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                {renderButtons()}
            </div>
        </div>
    );
};




// ****************************************
// import { useLocation } from 'react-router-dom';
// import React, { useEffect, useRef, useState } from 'react';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { theme } from '../constants';
// import { components } from '../components';
// import useApi from '../customHook/useApi';



// export interface VerifyOtpResponse {
//     success: boolean;
//     statusCode: number;
//     phoneNumber: string;
//     accessToken: string;
//     lead_profile_id: string;
//     message: string;
// }



// export const Onboarding4: React.FC = () => {
//     const location = useLocation();
//     // const { phonOtp } = location.state || {};
//     const { pathname } = useLocation();
//     const navigate = hooks.useNavigate();
//     const [otp, setOtp] = useState(['', '', '', '']);
//     const [expectedOtp, setExpectedOtp] = useState(""); // Store the OTP from state
//     const inputRefs = useRef<HTMLInputElement[]>([]);
//     const [error, setError] = useState("")





//     useEffect(() => {
//         console.log(location.state.otp, location.state.phoneNumber, "from navigation");
//     }, []);

//     const handleChange = (value: string, index: number) => {
//         if (!/^\d*$/.test(value)) return; // allow only numbers

//         const newOtp = [...otp];
//         newOtp[index] = value;
//         setOtp(newOtp);

//         if (value && index < 3) {
//             inputRefs.current[index + 1]?.focus();
//         }
//     };

//     const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
//         if (e.key === 'Backspace' && !otp[index] && index > 0) {
//             inputRefs.current[index - 1]?.focus();
//         }
//     };

//     const buttons = [
//         {
//             title: 'Verify',
//             path: '/onbording5',
//         }
//     ];


//     const {
//         data: verifyOtpResponse,
//         loading: verifyLoading,
//         callApi: verifyOtpApi,
//     } = useApi<VerifyOtpResponse>("/api/v1/verify-otp", {
//         method: "POST",
//         autoCall: false,
//         dependencies: [],
//     });


//     // const varifyOtp = (path: string) => {
//     //     console.log(path);
//     //     console.log(otp);
//     //     const enterdOtp = otp.join("")



//     //     if (otp.includes("")) {
//     //         setError('Please enter all 4 digits of the OTP');
//     //         return
//     //     }
//     //     // if (enterdOtp !== '0000') {
//     //     //     setError("Wrong OTP entered");
//     //     //     return
//     //     // }
//     //     setError('');
//     //     navigate(path);
//     // }

//     // Starts component s
//     const varifyOtp = async (path: string) => {
//         // console.log(otp);

//         const enteredOtp = otp.join("");

//         console.log(enteredOtp, "enteredOtp");


//         if (otp.includes("")) {
//             setError("Please enter all 4 digits of the OTP");
//             return;
//         }

//         try {
//             const res = await verifyOtpApi({
//                 body: {
//                     phoneNumber: location.state?.phoneNumber,  // <-- REQUIRED
//                     otp: Number(enteredOtp),                   // <-- USER INPUT
//                 },
//             });

//             console.log(res, " i am response");


//             if (res?.success) {
//                 console.log("OTP verified successfully:", res);

//                 // Optionally store data
//                 localStorage.setItem("accessToken", res.accessToken);
//                 localStorage.setItem("lead_profile_id", res.lead_profile_id);

//                 navigate(path, { state: res }); // pass verified data to next page
//             } else {
//                 setError(res?.message || "OTP verification failed");
//             }
//         } catch (error) {
//             console.error("Error verifying OTP:", error);
//             setError("Something went wrong. Please try again.");
//         }
//     };




